import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { FlowClient } from '@@api';

import { EntityMetadataModel } from '../../../api/api';
import useApiClient from '../../../common/hooks/useApiClient';

export default function useApiEntitySchemasOfContext(contextId: string | undefined): UseQueryResult<EntityMetadataModel[], Error> {
	const flowClient = useApiClient(FlowClient);
	const flowEntitySchemas = useQuery({
		queryKey: ['flow', 'entitySchemas', contextId],
		queryFn: () => (contextId ? flowClient.getEntities(contextId) : []),
	});
	return flowEntitySchemas;
}
